/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const HelpFilled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM10.549 6.43189C11.7413 5.71651 13.2675 5.90439 14.2507 6.88759C15.4988 8.13571 15.4202 10.1822 14.0801 11.3309L13.2089 12.0777C12.8932 12.3483 12.7115 12.7433 12.7115 13.159V14.5H11.2115V13.159C11.2115 12.3054 11.5845 11.4944 12.2327 10.9388L13.1039 10.1921C13.7806 9.61198 13.8203 8.57853 13.1901 7.94825C12.6936 7.45175 11.9229 7.35687 11.3208 7.71813L11.1511 7.81995C10.786 8.03901 10.5113 8.38145 10.3766 8.78538L10.173 9.39621L8.75 8.92187L8.95361 8.31104C9.20149 7.56741 9.70719 6.93699 10.3793 6.53371L10.549 6.43189ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z"
                        fill={color}
                    />
                </svg>
        );
    };
